// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.HomeType

export enum HomeType {
  OTHER = 'OTHER',
  OWN = 'OWN',
  RENT = 'RENT',
}

export const HomeType_values = [HomeType.OTHER, HomeType.OWN, HomeType.RENT] as const;
